<template>
  <div class="fshr-resortSkiTrails">
    <ul class="fshr-resortSkiTrails__list" v-if="trails.length">
      <li
        v-for="trail in trails"
        :key="trail.id"
        class="fshr-resortSkiTrails__item"
        :class="[trail.type && `fshr-resortSkiTrails__item--${trail.type}`]"
        v-tooltip="{
            content: getTranslation(`ski_trails_${trail.type}`),
            html: false,
            classes: 'fshr-basicTooltip',
            offset: 15,
        }"
      >
        {{ trail.length }} {{ getTranslation("kilometers_label") }}
      </li>
    </ul>
  </div>
</template>

<script>
import distanceMixin from "../../mixins/distanceMixin";

export default {
  name: "resort-trails",
  props: {
    trails: {
      type: Array,
      required: false,
      default: () => [],
    },
    translations: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  mixins: [distanceMixin],
};
</script>

<style lang="less">
  @import './../../less/variables';
  @import "./../../../../../../Content/css/common/component-ski-trails.less";
</style>
